<template>
  <div class="home">
    <div class="propaganda-img">
      <img src="../assets/propagandaimg/propaganda-1.jpeg" alt="">
    </div>
    <div class="propaganda-img" @click="openApp">
      <img src="../assets/propagandaimg/button-1.jpeg" alt="">
    </div>
    <div class="propaganda-img">
      <img src="../assets/propagandaimg/propaganda-2.jpeg" alt="">
    </div>
    <div class="propaganda-img">
      <img src="../assets/propagandaimg/propaganda-3.jpeg" alt="">
    </div>
    <div class="propaganda-img">
      <img src="../assets/propagandaimg/propaganda-4.jpeg" alt="">
    </div>
    <div class="propaganda-img">
      <img src="../assets/propagandaimg/propaganda-5.jpeg" alt="">
    </div>
    <div class="propaganda-img" @click="openApp">
      <img src="../assets/propagandaimg/button-2.jpeg" alt="">
    </div>
    <div class="propaganda-height"></div>
  </div>
</template>

<script>
import { iswx, wxshare } from '@/utils/utils.js'
// import { userSweepqrcode } from '@/api/resetApi.js'

export default {
  name: 'Home',
  data(){
    return{
      link:  window.location.protocol + '//' + window.location.host,
      ip: '',
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      openPopup: false,
      id: 'wxopenLanchAppId',
      appid: 'wxdc89dd9a7329fe47',
      wechatOpenAppData: '',
    }
  },
  created(){
    this.ip = returnCitySN['cip']
    // this.propaganda()
    let json = {
      "type": "propaganda",
      "linkId": ''
    }
    this.wechatOpenAppData = JSON.stringify(json)
    if (iswx() === true) {
      let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      console.log('wechat',wechat)
      let judgewechat = wechat[1].split('.')
      // this.text = judgewechat
      if (judgewechat[0]>=8) {
        this.openPopup = true
      } else if(judgewechat[0]>=7){
        if(judgewechat[1]>=0){
            this.text = judgewechat
          if(judgewechat[2]>=12){
            this.openPopup = true
            console.log("当前符合 h5 打开指定app")                    
          }
        }
      }
    }
  },
  mounted() {
    if (this.openPopup == true) {
      var btn = document.getElementById(this.id)
      btn.addEventListener('launch', e => {
        console.log('success');
      });
      btn.addEventListener('error',  e => {
        this.text = e.detail.errMsg
        if (e.detail.errMsg == 'launch:fail') {
          window.location = 'http://t.cn/Aijv8II4'
        } else {
          this.$createToast({
            txt: e.detail,
            type: 'error'
          }).show()
        }
      });
    }
  },
  methods: {
    openApp() {
      if (this.browser.android) {
        ZKAPP.zkmsy();
      }else {
        window.webkit.messageHandlers.zkmsy.postMessage({name: 'zhangyutang', age: 12});
      }
      // window.location = 'http://t.cn/Aijv8II4'
    },
    async propaganda() {
      let sys;
      if (this.browser.android) {
        sys = "Android";
      }else if (this.browser.iPhone){
        sys = "iPhone";
      } else if (this.browser.iPad) {
        sys = "iPad"; 
      }
      let qs = require('qs');
      let data = qs.stringify({
        lab_id: 'lzt',
        ip: this.ip,
        device_id: sys
      })
      const res = await userSweepqrcode(data)
      try {
        if (res.data.code === 1) {
          console.log('成功')
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
  }
}
</script>

<style lang="scss">
  .home {
    max-width: 768px;
    margin: 0 auto;
    .propaganda-img {
      font-size: 0;
      img {
        width: 100%;
      }
    }
    .propaganda-height {
      height: 60px;
      background: #0234f5;
    }
  }
</style>
